var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Device info: location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.46776C0 3.79865 3.75199 0 8.36329 0C12.9748 0 16.7268 3.79865 16.7273 8.46776C16.7273 9.68565 16.4813 10.8485 15.9958 11.9242C13.9041 16.5573 9.89496 21.4481 8.71622 22.8364C8.62787 22.9402 8.49906 23 8.36352 23C8.22798 23 8.09917 22.9402 8.01083 22.8364C6.83162 21.4479 2.82248 16.5568 0.731427 11.9242C0.246212 10.8485 0 9.68565 0 8.46776ZM4.0189 8.46748C4.0189 10.8927 5.9679 12.8659 8.36329 12.8659C10.7589 12.8659 12.7079 10.8927 12.7077 8.46748C12.7077 6.04206 10.7587 4.06883 8.36329 4.06883C5.9679 4.06883 4.0189 6.04206 4.0189 8.46748Z",
    fill: "#CFFF38"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.ace68130dcccd14b98838fac1b2ba63b.svg";
export { ForwardRef as ReactComponent };